/* eslint-disable */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useParams } from 'react-router';
import { showNotification } from '@mantine/notifications';
import { useMantineColorScheme } from '@mantine/core';
import { ReloadOutlined, LineChartOutlined } from '@ant-design/icons';
import { BeatLoader } from 'react-spinners';
import { ReportMoney, TableAlias, ChevronDown } from 'tabler-icons-react';
import {
  Table,
  Switch,
  Tooltip,
  Button,
  Space,
  Card,
  Tag,
  Typography,
  ConfigProvider
} from 'antd';
import Layout from '../../Layout/Layout';
import {
  assetPrefix,
  loadingStates,
  renderNumber
} from '../../../utilities/general';
import { apiWrapWithErrorWithData } from '../../../utilities/apis/apiHelpers';
import { companyPositionsApi, companyEntryPriceApi, companyGetEntryPriceApi, companyMissingPositionsApi } from '../../../utilities/apis/companyData';
import { missingPositionsData, incompleteMissingData } from '../companyData/BalanceSheet/dummy';
import { traderEntryPriceApi, traderGetEntryPriceApi, tradersMissingPositionsApi } from '../../../utilities/apis/traders';
import coinbaseWebSocket from '../../../utilities/websocket/coinbaseWebSocket';
import useSorting from '../../../components/CommonFunction/useSorting';
import styles from './LivePositionsStandalone.module.css';
import AddEntryPriceModal from '../../DetailPages/CommonDetailsComponent/AddEntryPriceModal';

const { Text, Title } = Typography;

const LivePositionsStandalone = () => {
  const { userId } = useParams();
  const [pageName] = useState('CompanyData');
  const [positionsData, setPositionsData] = useState();
  const [filteredPositionsData, setFilteredPositionsData] = useState([]);

  const [dataLoading, setDataLoading] = useState(loadingStates.NO_ACTIVE_REQUEST);
  const [checkboxes, setCheckboxes] = useState({
    removeDust: true,
  });
  const [livePrice, setLivePrice] = useState({});
  const [positionsQty, setPositionsQty] = useState({});
  const [openPositionsValue, setOpenPositionsValue] = useState({});
  const [hideAlert, setHideAlert] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loadingPositionId, setLoadingPositionId] = useState(null);
  const [saveState, setSaveState] = useState({ status: 'warning', message: '' });
  const [missingPositions, setMissingPositions] = useState();


  const { items: sortedMissingEntries } = useSorting(selectedPosition?.data, 'timestamp');

  const { colorScheme } = useMantineColorScheme();

  // Add pagination state
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  // Initialize WebSocket connection
  const initializeWebSocket = useCallback((symbolsList) => {
    coinbaseWebSocket.setMessageCallback((data) => {
      if (data.type === 'ticker' && data.price) {
        const { product_id: productId, price } = data;
        const symbol = productId.split('-')[0];
        const priceValue = parseFloat(price);

        setLivePrice((prevPrices) => ({
          ...prevPrices,
          [symbol]: priceValue,
        }));
      }
    });

    coinbaseWebSocket.connect();

    symbolsList.forEach((symbol) => {
      coinbaseWebSocket.subscribe(symbol);
      coinbaseWebSocket.subscribe(`${symbol}-USDT`);
    });
  }, []);

  const fetchPositionsData = async () => {
    setDataLoading(loadingStates.LOADING);
    let resp;

    resp = await apiWrapWithErrorWithData(companyPositionsApi('open'));

    if (resp?.success && resp?.data) {
      const updatedData = resp.data.map((item) => ({
        ...item,
      }));

      const livePriceData = {};
      const positionsQtyData = {};
      const openPositionsValueData = {};

      updatedData.forEach((position) => {
        const latestPrice = livePrice[position.asset.toUpperCase()] || position.latestPrice?.assetValue || 0;
        const valueOpenPositions = latestPrice * position.size;
        livePriceData[position.asset.toUpperCase()] = latestPrice;
        positionsQtyData[position.asset.toUpperCase()] = position.size;
        openPositionsValueData[position.asset.toUpperCase()] = valueOpenPositions;
      });

      setLivePrice(livePriceData);
      setPositionsQty(positionsQtyData);
      setOpenPositionsValue(openPositionsValueData);

      setPositionsData(updatedData);
      setFilteredPositionsData(updatedData);
      setPagination(prev => ({
        ...prev,
        total: updatedData.length,
        current: 1, // Reset to first page when data changes
      }));
      setDataLoading(loadingStates.FINISHED);

      const uniqueSymbols = [...new Set(resp.data.map((position) => position.asset))];
      initializeWebSocket(uniqueSymbols);
    } else {
      showNotification({
        color: 'red',
        message: 'Couldn\'t load positions data',
        title: 'Error while fetching positions',
      });
    }
  };

  useEffect(() => {
    fetchPositionsData();
    fetchMissingPositionsData();
  }, []);

  useEffect(() => {
    fetchPositionsData();
  }, [colorScheme]);





  // Calculate real-time values for positions
  const getRealTimePositionData = useCallback((position) => {
    const currentPrice = livePrice[position.asset.toUpperCase()] || position.latestPrice?.assetValue || 0;
    const entryPrice = position.entryPrice?.assetValue || 0;
    const size = position.size || 0;

    // Calculate current position value
    const currentPositionValue = currentPrice * size;

    // Calculate running P&L
    const runningPnL = (currentPrice - entryPrice) * size;
    const runningPnLPercentage = entryPrice > 0 ? ((currentPrice - entryPrice) / entryPrice) * 100 : 0;

    // Calculate change in asset value
    const changeAsset = currentPositionValue - (position.totalInvestment?.assetValue || 0);

    return {
      currentPrice,
      currentPositionValue,
      runningPnL,
      runningPnLPercentage,
      changeAsset,
    };
  }, [livePrice]);

  // Create processed data with calculated values for sorting
  const processedData = useMemo(() => {
    if (!filteredPositionsData) return [];

    return filteredPositionsData.map((position) => {
      const realTimeData = getRealTimePositionData(position);
      return {
        ...position,
        currentPositionValue: realTimeData.currentPositionValue,
        runningPnL: realTimeData.runningPnL,
        runningPnLPercentage: realTimeData.runningPnLPercentage,
        changeAsset: realTimeData.changeAsset,
      };
    });
  }, [filteredPositionsData, getRealTimePositionData]);

  // Calculate filtered data based on dust removal
  const newlyUpdatedData = useMemo(() => {
    return processedData?.filter((newItem) => {
      return newItem.currentPositionValue >= 1;
    }) || [];
  }, [processedData]);

  // Update pagination when filtered data changes
  useEffect(() => {
    const currentData = checkboxes?.removeDust ? newlyUpdatedData : processedData;
    if (currentData) {
      setPagination(prev => ({
        ...prev,
        total: currentData.length,
        // current: 1, // Reset to first page when filters change
        current: prev.current,
      }));
    }
  }, [processedData, checkboxes?.removeDust, newlyUpdatedData]);

  // When filter toggles (like removeDust)
  useEffect(() => {
    setPagination(prev => ({
      ...prev,
      current: 1, // Only reset when filter changes
    }));
  }, [checkboxes.removeDust]);

  // Calculate real-time summary data
  const getRealTimeSummary = useCallback(() => {
    const dataSource = checkboxes?.removeDust ? newlyUpdatedData : processedData;

    if (!dataSource || dataSource.length === 0) {
      return {
        totalPnL: 0,
        totalInvestment: 0,
        totalCurrentValue: 0,
      };
    }

    let totalPnL = 0;
    let totalInvestment = 0;
    let totalCurrentValue = 0;

    dataSource.forEach((position) => {
      totalPnL += position.runningPnL || 0;
      totalInvestment += position.totalInvestment?.assetValue || 0;
      totalCurrentValue += position.currentPositionValue || 0;
    });

    return {
      totalPnL,
      totalInvestment,
      totalCurrentValue,
    };
  }, [processedData, newlyUpdatedData, checkboxes.removeDust]);

  const {
    items: sortedItems,
    requestSort,
    sortConfig,
  } = useSorting(checkboxes?.removeDust ? newlyUpdatedData : processedData, 'totalInvestment.assetValue');

  // Get paginated items
  const getPaginatedItems = () => {
    const startIndex = (pagination.current - 1) * pagination.pageSize;
    const endIndex = startIndex + pagination.pageSize;
    return sortedItems.slice(startIndex, endIndex);
  };

  const items = getPaginatedItems();

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const getBgClass = (hasChanged, runningPnLPercentage) => {
    if (colorScheme === 'dark') {
      if (hasChanged) {
        return runningPnLPercentage > 0
          ? 'bg-green-900/40 animate-pulse'
          : 'bg-red-900/40 animate-pulse';
      }
      return '';
    }

    if (hasChanged) {
      return runningPnLPercentage > 0
        ? 'bg-green-100 animate-pulse'
        : 'bg-red-100 animate-pulse';
    }

    if (runningPnLPercentage > 0) return 'bg-green-50';
    if (runningPnLPercentage < 0) return 'bg-red-50';
    return 'bg-gray-50';
  };

  const GetClassName = (value, item) => {
    const itemValue = value === null ? Number.parseFloat(Number(value).toFixed(2)) : value;
    const totalValue = item === null ? Number.parseFloat(Number(item).toFixed(2)) : item;

    if (item) {
      switch (true) {
        case itemValue < totalValue:
          return 'text-red-500';
        case itemValue > totalValue:
          return 'text-green-500';
        default:
          return '';
      }
    }

    switch (true) {
      case itemValue === 0:
        return 'text-base';
      case itemValue < 0:
        return 'text-red-500';
      case itemValue > 0:
        return 'text-green-500';
      default:
        return '';
    }
  };

  // Define table columns with real-time data
  const getColumns = () => {
    const baseColumns = [
      {
        title: 'Asset',
        key: 'asset',
        dataIndex: 'asset',
        width: 113,
        render: (_, record) => {
          const realTimeData = getRealTimePositionData(record);
          return (
            <div className="flex items-center gap-3">
              {record?.icon ? (
                <img
                  className="w-11 h-11 rounded-full"
                  src={record?.icon || `${assetPrefix}/images/CrptoIcon.svg`}
                  alt="Crypto"
                />
              ) : (
                <ReportMoney className="w-11 h-11 text-blue-500" />
              )}
              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-2">
                  <Tooltip title={record?.asset} color="black" placement="top">
                    <Text strong className="text-base dark:text-white">
                      {record?.asset?.length > 8 ? `${record?.asset?.slice(0, 8)}...` : record?.asset || '-'}
                    </Text>
                  </Tooltip>
                  <Tooltip title={`View ${record?.asset} chart on TradingView`} placement="top">
                    <Button
                      type="text"
                      size="small"
                      icon={<LineChartOutlined className="text-gray-600 hover:text-blue-600" />}
                      onClick={() => {
                        const symbol = `${record?.asset?.toUpperCase()}USD`;
                        const url = `https://in.tradingview.com/chart/?symbol=COINBASE%3A${symbol}`;
                        window.open(url, '_blank');
                      }}
                      className="p-1 min-w-0 h-6 hover:bg-blue-50 transition-all duration-200"
                      style={{ borderRadius: '4px' }}
                    />
                  </Tooltip>
                </div>
                <Text type="secondary" className="text-sm dark:text-white">
                  {record?.tradingProductType?.toUpperCase()}
                </Text>
                <Text
                  className={`text-xs px-2 py-1 rounded transition-all duration-200 ${colorScheme === 'dark'
                    ? 'bg-[#26282C] text-white'
                    : 'bg-gray-50'
                    }`}
                >
                  ${realTimeData.currentPrice?.toFixed(4) || '0.0000'}
                </Text>
              </div>
            </div>
          );
        },
        sorter: true,
        sortOrder: getClassNamesFor('asset'),
        onHeaderCell: () => ({
          onClick: () => requestSort('asset'),
        }),
      },
      {
        title: 'Investment & Entry',
        key: 'investment',
        width: 75,
        render: (_, record) => (
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <Text strong className="text-base dark:text-[#BEB9B9]">
                {`${renderNumber(record?.totalInvestment?.assetValue) || ''} ${record?.totalInvestment?.symbol}`}
              </Text>
            </div>
            <div className="flex items-center gap-1 text-sm text-gray-600 dark:text-[#BEB9B9]">
              <span>{`${renderNumber(record?.entryPrice?.assetValue) || ''} ${record?.entryPrice?.symbol} x`}</span>
              <Tooltip title={record?.size} color="black" placement="top">
                <span className="font-medium">
                  [{record?.size ? `${renderNumber(record?.size)}` : '-'}]
                </span>
              </Tooltip>
            </div>
          </div>
        ),
        sorter: true,
        sortOrder: getClassNamesFor('totalInvestment.assetValue'),
        onHeaderCell: () => ({
          onClick: () => requestSort('totalInvestment.assetValue'),
        }),
      },
      {
        title: 'Current Value',
        key: 'currentValue',
        width: 113,
        sorter: true,
        sortOrder: getClassNamesFor('currentPositionValue'),
        onHeaderCell: () => ({
          onClick: () => requestSort('currentPositionValue'),
        }),
        render: (_, record) => {
          const realTimeData = getRealTimePositionData(record);
          const previousValue = (livePrice[record.asset.toUpperCase()] || record.latestPrice?.assetValue || 0) * (record.size || 0);
          const hasChanged = Math.abs(realTimeData.currentPositionValue - previousValue) > 0.01;

          return (
            <div className="flex flex-col gap-1">
              <Text
                strong
                className={`text-base px-2 py-1 rounded transition-all duration-200 
                  ${getBgClass(hasChanged, realTimeData.currentPositionValue)} 
                  ${GetClassName(realTimeData.runningPnLPercentage)}`}
              >
                {`${renderNumber(realTimeData.currentPositionValue) || ''} ${record?.totalInvestment?.symbol || ''}`}
              </Text>
              <div className="flex items-center gap-1 text-sm text-gray-600 dark:text-[#BEB9B9]">
                <span className={GetClassName(realTimeData.currentPrice, record?.entryPrice?.assetValue)}>
                  {`${renderNumber(realTimeData.currentPrice) || ''} ${record?.latestPrice?.symbol} x`}
                </span>
                <Tooltip title={record?.size} color="black" placement="top">
                  <span className="font-medium">
                    [{record?.size ? `${renderNumber(record?.size)}` : '-'}]
                  </span>
                </Tooltip>
              </div>
            </div>
          );
        },
      },
      {
        title: 'Performance',
        key: 'performance',
        width: 113,
        render: (_, record) => {
          const realTimeData = getRealTimePositionData(record);
          const previousPercentage = record?.change?.percentage * 100 || 0;
          const hasChanged = Math.abs(realTimeData.runningPnLPercentage - previousPercentage) > 0.01;

          return (
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <Text
                  strong
                  className={`text-base px-2 py-1 rounded transition-all duration-200
                     ${getBgClass(hasChanged, realTimeData.runningPnLPercentage)} 
                     ${GetClassName(realTimeData.runningPnLPercentage)}`
                  }
                >
                  {`${realTimeData.runningPnLPercentage.toFixed(2)}%`}
                </Text>
                {realTimeData.runningPnLPercentage !== 0 && (
                  <img
                    className="w-4 h-4"
                    src={realTimeData.runningPnLPercentage > 0 ? `${assetPrefix}/images/GreenArrow.svg` : `${assetPrefix}/images/RedArrow.svg`}
                    alt="ArrowIcon"
                  />
                )}
              </div>
              <Text
                type="secondary"
                className={`text-sm dark:text-[#BEB9B9] ${GetClassName(realTimeData.changeAsset)}`}
              >
                {`${renderNumber(realTimeData.changeAsset) || ''} ${record?.entryPrice?.symbol}`}
              </Text>
            </div>
          );
        },
        sorter: true,
        sortOrder: getClassNamesFor('runningPnLPercentage'),
        onHeaderCell: () => ({
          onClick: () => requestSort('runningPnLPercentage'),
        }),
      },


    ];

    return baseColumns;
  };

  const handleTableChange = (paginationInfo, filters, sorter) => {
    // Handle pagination
    if (paginationInfo.current !== pagination.current || paginationInfo.pageSize !== pagination.pageSize) {
      setPagination(prev => ({
        ...prev,
        current: paginationInfo.current,
        pageSize: paginationInfo.pageSize,
      }));
    }

    // Handle sorting
    if (sorter.field) {
      requestSort(sorter.field);
    }
  };

  // Get real-time summary data
  const summaryData = getRealTimeSummary();

  const handlerHideAlert = () => {
    setHideAlert((prev) => !prev);
  };

  const fetchMissingEntryPriceData = async (val) => {
    // start loader
    setLoadingPositionId(val?.positionId);

    // let resp;
    // if (pageName === 'CompanyData') {
    const resp = await apiWrapWithErrorWithData(companyGetEntryPriceApi(val?.positionId));
    // } else {
    //   resp = await apiWrapWithErrorWithData(traderGetEntryPriceApi(userId, val?.positionId));
    // }
    if (resp?.success && resp?.data) {
      const finalPositionData = {
        positionId: val?.positionId,
        asset: val?.asset,
        quantity: val?.size,
        data: [...resp.data]
          .reverse()
          .map((item) => ({
            userId: item.user_id,
            positionId: item.position_id,
            price: item.price,
            quantity: item.quantity,
            aggregated: item.aggregated,
            timestamp: item.createdAt,
          })),
      };
      setSelectedPosition(finalPositionData);
      setShowModal(true);
      setLoadingPositionId(null);
      setDataLoading(loadingStates.FINISHED);
    } else {
      showNotification({
        color: 'red',
        message: `Couldn't load entry prices for position ${val?.positionId}`,
        title: 'Error',
      });
    }
  };

  const fetchMissingPositionsData = async () => {
    // setDataLoading(loadingStates.LOADING);
    let resp;

    resp = await apiWrapWithErrorWithData(companyMissingPositionsApi('incomplete'));

    if (resp?.success && resp?.data) {
      setMissingPositions(resp?.data);
      setDataLoading(loadingStates.FINISHED);
    } else {
      showNotification({
        color: 'red',
        message: `Couldn't load missing positions for trader ${userId}`,
        title: 'Error while fetching missing positions',
      });
    }
  };


  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedAsset(null);
  };

  const handleSubmitSaveEntries = async (entries) => {
    // let resp;
    setSaveState({ status: 'loading', message: '' });
    // if (pageName === 'CompanyData') {
    const resp = await apiWrapWithErrorWithData(companyEntryPriceApi(entries));
    // } else {
    //   resp = await apiWrapWithErrorWithData(traderEntryPriceApi(userId, entries));
    // }

    if (resp?.success) {
      // success
      setSaveState({ status: 'success', message: 'Data added successfully.' });
    } else {
      const msg = resp?.message || 'Found error, please try again';
      setSaveState({ status: 'error', message: msg });
    }
  };
  const isEmpty = dataLoading === loadingStates.FINISHED && !processedData?.length && positionsData !== undefined;

  return (
    <ConfigProvider
      theme={{
        components:
          colorScheme === 'dark'
            ? {
              Table: {
                headerBg: "#1a1b1e",
                // headerSplitColor: "red",
                headerColor: "#BEB9B9",
                // bodySortBg: "#1A1A1A",
                bodySortBg: "#26282C",
                headerSortActiveBg: "#3A3F47", // active
                headerSortHoverBg: "#444A53",  // hover
                rowHoverBg: "#26282C",
                borderColor: "#3F3F3F",
              },
              Pagination: {
                colorPrimary: "#898989", // active color
                colorText: "#898989", // normal text
                colorTextDisabled: "#555", // disabled state
                itemBg: "#26282C", // normal background
                itemActiveBg: "#1a1b1e", // active background
                itemInputBg: "#1a1b1e", // quick jumper input
                itemLinkBg: "#26282C", // prev/next buttons
                itemLinkHoverBg: "#3A3F47", // hover state
                itemHoverColor: "#898989", // text hover
                colorPrimaryHover: "#898989"
              },
              Select: {
                optionSelectedBg: "#3A3F47",   // selected option bg
                optionActiveBg: "#26282C",     // hover bg for option
                selectorBg: "#1a1b1e",         // box background
                colorText: "#898989",          // text color
                colorBorder: "#3F3F3F",        // border color
                colorBgElevated: "#26282C",    // dropdown panel bg
                hoverBorderColor: "#3F3F3F",
                activeBorderColor: "#3F3F3F",
              },
              Input: {
                colorBgContainer: "#1a1b1e",
                colorBorder: "#3F3F3F",
                colorText: "#BEB9B9",
                colorBgContainerDisabled: "#2A2A2A",
              }
            }
            : {},
      }}
    >
      <div className="w-full flex h-full">
        <Layout>
          <div className="flex flex-col w-[95%] mx-auto mt-6 px-6 gap-6 mb-20">
            {/* Header Section */}
            <div className="flex items-center justify-between">
              <div>
                <Title level={2} className="mb-2 dark:text-white">Live Positions</Title>
                <Text type="secondary" className='dark:text-[#898989]'>Monitor your active trading positions in real-time</Text>
              </div>
              <Space>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={fetchPositionsData}
                  loading={dataLoading === loadingStates.LOADING}
                  type="default"
                  className={colorScheme === 'dark' && 'bg-[#26282C] text-white border-[#26282C] hover:!bg-[#1a1b1e] hover:!text-white hover:!border-[#26282C]'}
                >
                  Refresh
                </Button>

                <div className="flex items-center gap-2">
                  <Text className='dark:text-[#898989]'>Remove Dust:</Text>
                  <Switch
                    className={colorScheme === 'dark' && 'bg-[#414348]'}
                    checked={checkboxes.removeDust}
                    onChange={(checked) => setCheckboxes(prev => ({ ...prev, removeDust: checked }))}
                    disabled={positionsData?.length === 0}
                  />
                </div>
              </Space>
            </div>



            {/* Performance Summary Cards */}
            <div className="grid grid-cols-3 gap-4 mb-4">
              <Card className={`text-center ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
                <div className={`text-2xl font-bold ${GetClassName(summaryData.totalPnL)}`}>
                  {renderNumber(summaryData.totalPnL) || '0.00'}
                </div>
                <div className="text-sm text-gray-600 dark:text-[#898989]">Total P&L (Live)</div>
              </Card>
              <Card className={`text-center ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
                <div className="text-2xl font-bold text-blue-600">
                  {renderNumber(summaryData.totalInvestment) || '0.00'}
                </div>
                <div className="text-sm text-gray-600 dark:text-[#898989]">Total Investment</div>
              </Card>
              <Card className={`text-center ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
                <div className={`text-2xl font-bold ${GetClassName(summaryData.totalCurrentValue, summaryData.totalInvestment)}`}>
                  {renderNumber(summaryData.totalCurrentValue) || '0.00'}
                </div>
                <div className="text-sm text-gray-600 dark:text-[#898989]">Current Value (Live)</div>
              </Card>
            </div>



            {/* Table Section */}
            <Card className='dark:bg-[#26282C] dark:border-[#26282C]'>
              <div className="flex flex-col gap-5">
                {missingPositions?.length > 0 && (
                  <div className={`w-full flex flex-col gap-4 border ${colorScheme === 'dark' && 'border-neutral-600'} rounded-md p-3`}>
                    <div className="flex items-center gap-4 dark:text-[#BEB9B9]">
                      <div>
                        <span className="text-sm font-bold">{`${missingPositions?.length} position missing entry price `}</span>
                        — Please provide entry prices to display complete position data and accurate P&L calculations.
                      </div>
                      <div className="flex gap-2 items-center text-sm font-semibold cursor-pointer" onClick={handlerHideAlert}>
                        {hideAlert ? 'Hide' : 'Show'}
                        <ChevronDown size={16} color="#717182" className={`transition-transform ${hideAlert ? 'rotate-180' : ''}`} />
                      </div>
                    </div>
                    {hideAlert && (
                      <div className={`w-full flex flex-col items-start border ${colorScheme === 'dark' && 'border-neutral-600'} rounded-md`}>
                        <div className={`w-full grid items-center px-6 py-3 rounded-t-md border-b ${colorScheme === 'dark' ? 'border-neutral-600' : 'bg-[#F9FAFB80]'} ${styles.missingPositionsHeadingGrid}`}>
                          <div className="text-sm font-semibold text-[#0a0a0a] dark:text-[#BEB9B9]">
                            Asset
                          </div>
                          <div className="text-sm font-semibold text-[#0a0a0a] dark:text-[#BEB9B9]">
                            Quantity
                          </div>
                          <div className="text-sm font-semibold text-[#0a0a0a] dark:text-[#BEB9B9]">
                            Platform
                          </div>
                          <div className="text-sm font-semibold text-[#0a0a0a] dark:text-[#BEB9B9]">
                            Action
                          </div>
                        </div>
                        {missingPositions?.map((missingItem) => (
                          <div className={`w-full grid items-center px-6 dark:text-[#BEB9B9] py-3 border-b last:border-none ${colorScheme === 'light' ? 'hover:bg-gray-100 border-[#0000001A]' : 'border-neutral-600'} rounded-t-md ${styles.missingPositionsRowGrid}`}>
                            <div className="flex items-center gap-3 text-sm font-normal">
                              {missingItem?.icon
                                ? (
                                  <img
                                    className="w-10 h-10 rounded-full"
                                    src={missingItem?.icon || `${assetPrefix}/images/CrptoIcon.svg`}
                                    alt="Crypto"
                                  />
                                )
                                : <ReportMoney className="w-10 h-10" />}

                              <div className="flex flex-col gap-1 capitalization">
                                <Tooltip label={missingItem?.asset} color="black" withArrow>
                                  <span
                                    className={`${styles.title} text-sm`}
                                  >
                                    {missingItem?.asset?.length > 8 ? `${missingItem?.asset?.slice(0, 8)}...` : missingItem?.asset || '-'}
                                  </span>
                                </Tooltip>
                                <span
                                  className={`${styles.subTitle} text-sm`}
                                >
                                  {missingItem?.tradingProductType?.toUpperCase()}
                                </span>
                              </div>
                            </div>
                            <div className="text-sm">
                              <Tooltip label={missingItem?.size} color="black" withArrow>
                                <span>
                                  {missingItem?.size ? `${renderNumber(missingItem?.size)}` : '-'}
                                </span>
                              </Tooltip>
                            </div>
                            <div className="text-sm">
                              <Tooltip withArrow label={missingItem?.platform}>
                                <span>
                                  {missingItem?.platform?.length > 8 ? `${missingItem?.platform?.slice(0, 8)}...` : missingItem?.platform || '-'}
                                </span>
                              </Tooltip>
                            </div>
                            <div>
                              <span
                                key={missingItem.positionId}
                                // onClick={() => handleAddEntryPrice(missingItem)}
                                onClick={() => fetchMissingEntryPriceData(missingItem)}
                                className={`${loadingPositionId === missingItem.positionId ? 'flex justify-center items-center w-[107px] h-[35px]' : ''} p-2 border ${colorScheme === 'dark' && 'border-neutral-600'} rounded-lg text-sm cursor-pointer`}
                              >
                                {loadingPositionId === missingItem.positionId ? (
                                  <BeatLoader size={6} color={colorScheme === 'dark' ? '#D1D5DC' : '#0A0A0A'} />
                                ) : (
                                  'Add Entry Price'
                                )}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                <Table
                  key={`${pagination.current}-${pagination.pageSize}`}
                  columns={getColumns()}
                  dataSource={items}
                  loading={dataLoading === loadingStates.LOADING}
                  pagination={{
                    ...pagination,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} positions`,
                    pageSizeOptions: ['50', '100', '200', '500'],
                    position: ['bottomCenter'],
                    className: colorScheme === "dark" ? styles.darkPagination : "",
                  }}
                  onChange={handleTableChange}
                  rowKey="positionId"
                  scroll={{ x: 900 }}
                  className={`${styles['modern-table']} ${colorScheme === "dark" ? styles.darkTable : ""}`}
                  rowClassName={(record, index) =>
                    colorScheme === "dark"
                      ? "!bg-[#1a1b1e]"
                      : index % 2 === 0
                        ? "bg-gray-50 hover:bg-blue-50"
                        : "bg-white hover:bg-blue-50"
                  }
                />
              </div>
            </Card>

            {/* No Data State */}
            {isEmpty && (
              <Card className="text-center py-16 dark:bg-[#1a1b1e]">
                <TableAlias className="text-6xl text-gray-300 mb-4" />
                <Title level={4} type="secondary" className='dark:text-[#898989]'>No Positions Found</Title>
                <Text type="secondary" className='dark:text-[#898989]'>There are currently no active positions to display.</Text>
              </Card>
            )}
          </div>

          {showModal && selectedPosition && (
            <AddEntryPriceModal
              isOpen={showModal}
              setIsOpen={setShowModal}
              position={selectedAsset}
              selectedPosition={selectedPosition}
              onClose={handleCloseModal}
              onSave={handleSubmitSaveEntries}
              saveState={saveState}
              setSaveState={setSaveState}
              sortedMissingEntries={sortedMissingEntries}
            />
          )}
        </Layout>
      </div>
    </ConfigProvider>
  );
};

export default LivePositionsStandalone;
